module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/de5fcb9a50a24d4b4958026256ee352a.gif";